import { makeStyles } from 'tss-react/mui'
export const logInStyles = makeStyles()(theme => {
  return {
    myworkLogo: {
      minWidth: '100px',
      width: '10vw',
      padding: '20px'
    },
    mainContainer: {
      margin: '0px !important',
      padding: '0px !important',
      maxWidth: '1980px !important'
    },
    mainItem: {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none',
      maxWidth: '30em'
    },
    mainTitle: {
      fontFamily: 'Rubik',
      fontSize: '28px',
      fontWeight: '700',
      lineHeight: '33.18px',
      textAlign: 'center'
    },
    signMessage: {
      fontWeight: '300',
      fontFamily: 'Rubik',
      color: theme.colors.loadingRing,
      fontSize: '14px !important'
    },
    iconsContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    connectIcon: {
      width: '100%',
      position: 'relative',
      marginLeft: '20px',
      paddingRight: '30px'
    },
    ftcIcon: {
      position: 'relative'
    },
    icon: {
      top: '-1px',
      width: '24px',
      height: '24px',
      position: 'relative'
    },
    iconSpan: {
      width: '24px',
      height: '26px'
    },
    title: {
      fontWeight: '700',
      [theme.breakpoints.down('md')]: {
        fontSize: '24px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '40px'
      }
    },
    subtitle: {
      fontWeight: '400',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '20px'
      }
    },
    buttons: {
      maxWidth: '560px',
      width: 'calc(100vw - 40px)',
      margin: '0px auto',
      marginTop: theme.spacing(4)
    },
    link: {
      fontWeight: '400',
      color: theme.colors.text,
      textDecoration: 'none',
      fontFamily: 'Rubik',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '14px'
      }
    },
    linkBox: {
      paddingTop: '10px',
      paddingRight: '6px'
    },
    buttonsBox: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    rememberMe: {
      fontWeight: '400',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '14px !important'
      }
    },
    errorMessage: {
      color: `${theme.colors.errorText} !important`,
      fontWeight: '300 !important',
      fontSize: '12px !important'
    },
    terms: {
      fontWeight: '400 !important',
      fontSize: '12px !important',
      [theme.breakpoints.down('md')]: {
        display: 'none'
      },
      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    },
    linkTerms: {
      fontSize: '12px !important',
      color: theme.palette.primary.main,
      textDecoration: 'none'
    },
    signWith: {
      width: '100% !important',
      fontSize: '20px !important',
      padding: '6px 10px',
      borderRadius: '15px !important'
    },
    signWithGrid: {
      width: '100%',
      fontSize: '20px',
      [theme.breakpoints.down('md')]: {
        padding: '4px 16px !important'
      },
      [theme.breakpoints.up('md')]: {
        padding: '16px !important'
      }
    },
    boxSignWith: {
      [theme.breakpoints.down('md')]: {
        marginTop: '15px'
      },
      [theme.breakpoints.up('md')]: {
        width: '570px',
        margin: '40px auto 0px auto',
        paddingLeft: '3%'
      }
    },
    fields: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '3px',
        fontSize: '14px',
        height: '36px',
        maxWidth: '560px',
        width: 'calc(100vw - 40px)',
        fontFamily: 'Rubik Light'
      },
      '& .MuiFormControl-root': {
        width: '530px'
      },
      '& .MuiInputBase-root': {
        '& input': {
          WebkitBoxShadow: '0 0 0 1000px white inset'
        }
      }
    },
    requestButton: {
      [theme.breakpoints.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints.up('md')]: {
        width: '211px'
      }
    },
    singButton: {
      [theme.breakpoints.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints.up('md')]: {
        width: '129px'
      }
    },
    rememberForgot: {
      maxWidth: '560px',
      width: 'calc(100vw - 40px)',
      margin: '0px auto'
    },
    signinIcon: {
      width: '310px'
    },
    signDivider: {
      margin: '40px auto !important',
      width: '550px'
    },
    contactUs: {
      fontSize: '14px !important',
      fontWeight: '400 !important',
      marginTop: '6px !important'
    },
    version: {
      fontSize: '20px !important',
      fontWeight: '300 !important'
    }
  }
})

export const forgotPasswordStyles = makeStyles()(theme => {
  return {
    myworkLogo: {
      minWidth: '100px',
      width: '10vw',
      padding: '20px'
    },
    errorText: {
      color: `${theme.colors.errorText} !important`,
      fontWeight: '300 !important',
      fontSize: '12px !important'
    },
    mainItem: {
      position: 'fixed',
      overflow: 'hidden',
      maxWidth: '30em'
    },
    subtitle: {
      fontWeight: '400',
      fontFamily: 'Rubik Light',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
        display: 'block',
        lineHeight: '21px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '20px'
      }
    },
    link: {
      color: theme.palette.primary.text,
      textDecoration: 'none',
      margin: 'auto',
      fontSize: '18px'
    },
    title: {
      '&.MuiTypography-root': {
        fontWeight: '700',
        fontFamily: 'Rubik Bold',
        lineHeight: 1.5,
        [theme.breakpoints.down('md')]: {
          fontSize: '24px'
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '30px'
        }
      }
    },
    emailText: {
      fontFamily: 'Rubik Light',
      fontSize: '14px'
    },
    emailField: {
      marginTop: '0px',
      fontWeight: '400',
      '& fieldset': {
        borderRadius: '3px',
        border: `1px solid ${theme.colors.inputBorder}`,
        borderWidth: '1px'
      }
    },
    sendButton: {
      height: '61px',
      [theme.breakpoints.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints.up('md')]: {
        width: '5em'
      }
    },
    sendButtonBox: {
      paddingTop: '10px',
      [theme.breakpoints.down('md')]: {
        marginLeft: 0,
        marginTop: '0px',
        width: '100%'
      },
      [theme.breakpoints.up('md')]: {
        marginLeft: '-10px'
      }
    },
    buttonsBox: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: '20px'
    },
    backToSignInBox: {
      justifyContent: 'center',
      display: 'flex'
    },
    linkBox: {
      width: 'max-content',
      display: 'flex'
    },
    fieldsOutlined: {
      [theme.breakpoints.down('md')]: {
        borderRadius: '4px'
      },
      [theme.breakpoints.up('md')]: {
        borderRadius: '4px 0px 0px 4px',
        borderRight: 'none'
      },
      fontSize: '24px'
    },
    mainGrid: {
      minHeight: '70vh',
      transform: 'scale(0.80)'
    },
    formElementsContainer: {
      width: '70%'
    }
  }
})

export const forgotPasswordChangedStyles = makeStyles()(theme => {
  return {
    mainGrid: {
      minHeight: '70vh',
      transform: 'scale(0.80)'
    },
    title: {
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: '24px',
        margin: '0px 30px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '40px'
      }
    },
    subtitle: {
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
        margin: '10px 30px',
        display: 'block',
        lineHeight: '21px'
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '20px'
      }
    },
    buttons: {
      marginTop: theme.spacing(4)
    },
    resetButton: {
      [theme.breakpoints.down('md')]: {
        width: '60%',
        height: '58px'
      },
      [theme.breakpoints.up('md')]: {
        width: 'auto'
      }
    },
    buttonGrid: {
      width: '100%',
      textAlign: 'center'
    }
  }
})

export const forgotPasswordCodeStyles = makeStyles()(theme => {
  return {
    mainGrid: {
      minHeight: '70vh',
      transform: 'scale(0.80)'
    },
    mainItem: {
      maxWidth: '30em',
      [theme.breakpoints.down('md')]: {
        paddingTop: '1em'
      },
      [theme.breakpoints.up('md')]: {
        paddingTop: '4em'
      }
    },
    icon: {
      width: '1em',
      position: 'relative',
      top: '-4px'
    },
    title: {
      '&.MuiTypography-root': {
        fontFamily: 'Rubik Bold',
        fontWeight: '700',
        [theme.breakpoints.down('md')]: {
          fontSize: '20px',
          marginBottom: '10px'
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '30px'
        }
      }
    },
    buttons: {
      marginTop: theme.spacing(4)
    },
    fieldsOutlined: {
      borderRadius: '4px'
    },
    formBox: {
      [theme.breakpoints.down('md')]: {
        marginTop: '0px'
      },
      [theme.breakpoints.up('md')]: {
        marginTop: '32px'
      }
    },
    fields: {
      marginTop: '0px',
      fontSize: '20px',
      fontWeight: '400',
      '& fieldset': {
        borderRadius: '40px',
        border: `1px solid ${theme.colors.inputBorder}`,
        borderWidth: '1px'
      }
    },
    resetButton: {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '58px'
      },
      [theme.breakpoints.up('md')]: {
        width: 'auto'
      }
    },
    buttonGrid: {
      width: '100%',
      textAlign: 'right'
    },
    errorBox: {
      height: '22.5px',
      position: 'absolute'
    },
    errorMessage: {
      align: 'left',
      '&.MuiTypography-root': {
        color: theme.colors.errorText,
        fontWeight: '400',
        fontSize: '15px'
      }
    }
  }
})

export const forgotPasswordEmailSentStyles = makeStyles()(theme => {
  return {
    mainGrid: {
      minHeight: '70vh',
      transform: 'scale(0.80)'
    },
    title: {
      '&.MuiTypography-root': {
        fontFamily: 'Rubik Bold',
        fontWeight: '700',
        fontSize: '30px'
      }
    },
    subtitle: {
      '&.MuiTypography-root': {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '17px',
        whiteSpace: 'pre-line'
      }
    },
    linkBox: {
      width: 'max-content',
      display: 'flex'
    },
    link: {
      color: theme.palette.primary.text,
      textDecoration: 'none',
      margin: 'auto',
      fontSize: '18px'
    }
  }
})

export const logInContainerStyles = makeStyles()(theme => {
  return {
    privacyPolicyLink: {
      fontSize: '12px !important',
      color: theme.palette.primary.main,
      textDecoration: 'none'
    },
    signInMessageContainer: {
      textAlign: 'center'
    },
    allRightsReservedText: {
      fontSize: '12px',
      fontFamily: 'Rubik',
      lineHeight: '14px',
      fontWeight: '400'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: theme.colors.backdropColor
    },
    body: {
      backgroundColor: theme.colors.backdropColor,
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none'
    },
    section: {
      height: '100%',
      paddingTop: 5,
      backgroundColor: '#fff'
    },
    versionText: {
      fontSize: '20px',
      marginLeft: '30px',
      fontFamily: 'Rubik Light'
    },
    contactText: {
      fontSize: '14px',
      marginLeft: '30px',
      textDecoration: 'none',
      color: theme.colors.text
    },
    imageContainer: {
      marginTop: -60
    },
    iconsContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    connectIcon: {
      width: '400px',
      position: 'relative',
      marginLeft: '20px',
      paddingRight: '30px'
    },
    ftcIcon: {
      position: 'relative',
      width: '33px',
      height: '33px'
    },
    dialogPaper: {
      width: '577px',
      height: '250px',
      borderRadius: '9px'
    },
    dialogTitle: {
      fontWeight: '700',
      fontSize: '24px',
      textAlign: 'center',
      letterSpacing: '0.05em'
    },
    dialogContentFont: {
      fontSize: '18px',
      textAlign: 'center',
      color: theme.colors.basicDisabledButtonColor,
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: '21px'
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column'
    },
    dialogButtonContainer: {
      alignSelf: 'flex-end',
      marginBottom: '10px'
    },
    footerContainer: {
      zIndex: 10,
      paddingRight: '30px',
      position: 'fixed',
      bottom: '20px'
    }
  }
})
